import { createContext, useContext } from "react";

const CrewMembersActionsContext = createContext({
  edit(userId) {},
  roles(userId) {},
  positions(userId) {},
  operations(userId) {},
  aircraft(userId) {},
});

export default CrewMembersActionsContext;

export const useCrewMembersActions = () => useContext(CrewMembersActionsContext);
